import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'Components/Globals/Elements/Button/loadable';
import notFound from 'Assets/images/reports/Notfound.png';
import routes from 'Pages/router/constants/routes';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

const NotFound = () => {
	const { formatMessage } = useContent();
	const navigate = useNavigate();

	return (
		<div className={styles.card}>
			<img
				className={styles.stylesImg}
				src={notFound}
				alt={notFound}
			/>
			<p className={styles.title}>{formatMessage(strings.description)}</p>
			<Button
				label={formatMessage(strings.homeButton)}
				onClick={() => navigate(routes.dashboard)}
				className={'mt-24'}
			/>
		</div>
	);
};

export default NotFound;
